'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const TimeSeries=require('../../../../../../dist-es6/client/utilities/timeSeries');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

TimelineScheduleDirective=function(_BaseControllerBacked){_inherits(TimelineScheduleDirective,_BaseControllerBacked);function TimelineScheduleDirective(){_classCallCheck(this,TimelineScheduleDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(TimelineScheduleDirective,[{key:'objectBindings',get:function()
{
return[
'displayTimeZone',
'timezoneDescription',
'now',
'timeOfLastScheduleUpdate',
'timeOfLastHosStatus',
'invalidDataWarning',
'predictedWorkday',
'forecastDutyInterval',
'estimatesAsOfTime',
'timezone',
'dailySchedules',
'personalSchedule',
'fatigueThreshold',
'dutyFormatter',
'tripFormatter',
'sleepFormatter',
'sleepPromotingFormatter',
'personalStatistics',
'multiViewParent'];

}},{key:'templateUrl',get:function()

{
return'/templates/features/personalSchedule/components/timelineSchedule/timelineScheduleView';
}},{key:'controller',get:function()

{
return TimelineScheduleDirectiveController;
}}]);return TimelineScheduleDirective}(BaseControllerBackedDirective);let


TimelineScheduleDirectiveController=function(){
function TimelineScheduleDirectiveController($scope,$element,$timeout,displaySettingsService,timeFormattingService){var _this2=this;_classCallCheck(this,TimelineScheduleDirectiveController);

this._$timeout=$timeout;
this._displaySettingsService=displaySettingsService;
this._timeFormattingService=timeFormattingService;
this._element=$element[0];

const{fatigue:fatigue,sleep:sleep,queryInterval:queryInterval}=this.personalSchedule;
this._fatiguePoints=TimeSeries.assignWhenIntersectingOrOutside(fatigue,sleep,{notRendered:!0},queryInterval);

$scope.$watch('controller.personalSchedule',function(newSchedule,oldSchedule){
if(newSchedule.queryInterval.equals(oldSchedule.queryInterval)){
return;
}

$timeout(function(){return _this2.multiViewParent.reloadCurrentView()});
});

$scope.$on('resize::resize',function(){return _this2._onDimensionsChanged()});

this._onDimensionsChanged();
}TimelineScheduleDirectiveController.prototype.





























_onDimensionsChanged=function _onDimensionsChanged(newDimensions,oldDimensions){var _this3=this;
const newWidth=Math.floor((this.dailyDetailColumnsContainer.offsetWidth-this.detailsLabelColumn.offsetWidth)/7);

if(newWidth===this.dailySummaryColumnWidth){
return;
}

this._$timeout(function(){
_this3.dailySummaryColumnWidth=newWidth;
});
};_createClass(TimelineScheduleDirectiveController,[{key:'timeFormattingService',get:function(){return this._timeFormattingService}},{key:'use24HourTimeline',get:function(){return this._timeFormattingService.safeUse24HourTimelineSetting}},{key:'fatiguePoints',get:function(){return this._fatiguePoints}},{key:'dailyDetailColumnsContainer',get:function(){return this._dailyDetailColumnsContainer||(this._dailyDetailColumnsContainer=angular.element(this._element).find('.schedule-daily-detail-columns')[0])}},{key:'detailsLabelColumn',get:function(){return this._detailsLabelColumn||(this._detailsLabelColumn=angular.element(this._element).find('.schedule-row-titles-column')[0])}},{key:'dailySummaryColumnWidth',set:function(newWidth){this._displaySettingsService.renderCache.columnWidthForTimelineScheduleGraph=newWidth},get:function(){return this._displaySettingsService.renderCache.columnWidthForTimelineScheduleGraph}}]);return TimelineScheduleDirectiveController}();


module.exports=TimelineScheduleDirective;
//# sourceMappingURL=timelineScheduleDirective.js.map
